export function stationaryFix(device, now) {
  return device?.status === 'active' && Number.isFinite(device.speed) && device.speed === 0
    && Number.isFinite(device.accuracy) && device.accuracy >= 0 && device.accuracy <= 35
    && Number.isFinite(device.requestedAt) && now >= device.requestedAt
    && now - device.requestedAt <= 15000;
}

// Require distinct measured stationary fixes; a timer replay is not evidence.
export function stationaryDwell(previous, device, now) {
  if (!stationaryFix(device, now)) return null;
  const time = device.requestedAt;
  if (!previous || time < previous.last || time - previous.last > 15000)
    return { first: time, last: time, ready: false };
  if (time === previous.last) return previous;
  return { first: previous.first, last: time, ready: time - previous.first >= 3000 };
}

export function motionQuiet(motion, now) {
  return motion?.state === 'quiet' && Number.isFinite(motion.capturedAt)
    && now >= motion.capturedAt && now - motion.capturedAt <= 3000;
}
